const filterLoanBossFields = field => {
  if (!!field.reportGroupId) {
    return field;
  }
  if (field.level === "deal" && (
    field.loanBossField === "d2ae6abe-080b-11eb-867f-f1f1e6aba435" ||
      field.loanBossField === "681d843a-2e11-11e9-ac70-0242ac140002" ||
      field.loanBossField === "681d83ea-2e11-11e9-ac70-0242ac140002")) {
    return field;
  }
  if (field.level === "property" && (
    field.loanBossField === "appraisedValue" ||
    field.loanBossField === "marketValue")) {
    return field;
  }

  return null;
};

const filterHardCodedFields = field => {
  if (field.type === "dollars" || field.type === "mm") {
    return field;
  }

  return null;
};

const filterRentRollFields = field => {
  if (field.actualVacancyType && field.actualVacancyType === "dollars") {
    return field;
  }
  if (field.vacancyRateType && field.vacancyRateType === "minimum") {
    return field;
  }

  return null;
};

export const filterNonMonetaryFields = allFields => {
  const monetaryFields = [];
  if (!allFields || allFields.length === 0) {
    return allFields;
  }

  for (const field of allFields) {
    if (field.isFromLoanBoss) {
      const temp = filterLoanBossFields(field);
      if (temp) {
        monetaryFields.push(temp);
      }
    }

    if (field.isHardCoded) {
      const temp = filterHardCodedFields(field);
      if (temp) {
        monetaryFields.push(temp);
      }
    }

    if (field.isFromRentRoll) {
      const temp = filterRentRollFields(field);
      if (temp) {
        monetaryFields.push(temp);
      }
    }

    if (field.isFromFile) {
      monetaryFields.push(field);
    }

    if (field.isCalculated) {
      monetaryFields.push(field);
    }
  }

  return monetaryFields;
};

const checkNoiFieldReferenceInCalculatedField = (field, allFields, noiType, reportGroupId) => {
  const { calculations } = field;

  let shouldExclude = false;

  for (const calculation of calculations) {
    const fieldUsed = allFields.find((f) => f.id === calculation.fieldId);
    if (fieldUsed && fieldUsed.isFromLoanBoss && fieldUsed.reportGroupId === reportGroupId && fieldUsed.noiType === noiType) {
      shouldExclude = true;
    }
  }

  return shouldExclude;
};

const checkIfNoiFieldAlreadyUsed = (noiType, expenseLineItems, incomeLineItems, allFields) => {
  const lineItemsToCheck = noiType === "income" ? expenseLineItems : incomeLineItems;

  const fieldsUsed = [];
  for (const lineItem of lineItemsToCheck) {
    if (lineItem.isMultipleProperties) {
      if (!lineItem.isComparison) {
        const fieldsPerProperty = lineItem.multiplePropertiesValueFields;
        for (const propertyField of fieldsPerProperty) {
          const field = propertyField.selectedField;
          if (field) {
            fieldsUsed.push(field);
          }
        }
      } else {
        const multiplePropertiesComparisonFields = lineItem.multiplePropertiesComparisonFields;
        for (const comparisonGroup of multiplePropertiesComparisonFields) {
          for (const propertyField of comparisonGroup) {
            if (propertyField.selectedField) {
              fieldsUsed.push(propertyField.selectedField);
            }
          }
        }
      }
    } else {
      if (!lineItem.isComparison) {
        fieldsUsed.push(lineItem.field);
      } else {
        const comparisonFields = lineItem.comparisonFields;
        fieldsUsed.push(...comparisonFields);
      }
    }
  }

  for (const field of fieldsUsed) {
    if (field.isFromLoanBoss && field.reportGroupId) {
      return true;
    }

    if (field.isCalculated) {
      const { calculations } = field;
      for (const calculation of calculations) {
        const noiField = allFields.find((f) => f.id === calculation.fieldId);
        if (noiField && noiField.isFromLoanBoss && noiField.reportGroupId) {
          return true;
        }
      }
    }
  }

  return false;
};

/*
  * Checks if noi field or calculated field using noi field should be filtered out.
  * Income NOI field can only be used in expense NOI module and vice versa.
*/
export const excludeByNoiType = (allFields, noiType, reportGroupId, expenseLineItems, incomeLineItems) => {
  if (!allFields || allFields.length === 0) {
    return allFields;
  }

  const noiFieldIds = allFields.filter(field => field.isFromLoanBoss && field.reportGroupId).map(field => field.id);

  const filteredFields = [];

  for (const field of allFields) {
    if (!field.isFromLoanBoss && !field.isCalculated) {
      filteredFields.push(field);
    }

    if (field.isFromLoanBoss) {
      if (!!field.reportGroupId) {
        if (field.noiType !== noiType && field.reportGroupId === reportGroupId) {
          // if expense or income module already includes Noi Field, then it should be excluded
          !checkIfNoiFieldAlreadyUsed(noiType, expenseLineItems, incomeLineItems, allFields) && filteredFields.push(field);
        }
      } else {
        filteredFields.push(field);
      }
    }

    if (field.isCalculated) {
      const hasNoiReference = field.calculations.some((calculation) => noiFieldIds.includes(calculation.fieldId));

      if (!hasNoiReference) {
        filteredFields.push(field);
      } else {
        const shouldExclude = checkNoiFieldReferenceInCalculatedField(field, allFields, noiType, reportGroupId);

        if (!shouldExclude) {
          !checkIfNoiFieldAlreadyUsed(noiType, expenseLineItems, incomeLineItems, allFields) && filteredFields.push(field);
        }
      }
    }
  }

  return filteredFields;
};
